import React from 'react'
import KeyMovementsScanner from './KeyMovementsScanner'
import { useHistory } from 'react-router-dom';
import usePaths from '../../../../utility/paths';

export const RoutedKeyMovementsScanner = () => {
  const history = useHistory();
  const paths = usePaths();

  return (
    <KeyMovementsScanner show onClose={() => history.push(paths.keyManager)} />
  )
}
